
import { Component, Vue, Emit, Prop, Watch } from 'vue-property-decorator';
import { CardColorTypes } from '../store/types';
import { CardColors } from '../store/types';
import { namespace } from 'vuex-class';

const globalModule = namespace('global');

@Component
export default class ColorPickerMenu extends Vue {
  @Prop({ type: String, required: true })
  selected!: string;
  open = false;

  @globalModule.Mutation
  setColorMenuOpen!: (payload: boolean) => void;

  get colors() {
    return CardColorTypes;
  }

  selectedIcon(color: string, blank: boolean): string {
    const defaultIcon = blank
      ? 'mdi-checkbox-blank-circle-outline'
      : 'mdi-checkbox-blank-circle';
    const checkedIcon = blank ? 'mdi-check-circle-outline' : 'mdi-checkbox-marked-circle';
    return this.selected === color ? checkedIcon : defaultIcon;
  }

  @Emit('color-selected')
  colorSelected(color: CardColors): CardColors {
    return color;
  }

  @Watch('open')
  menuChanged(val: boolean) {
    this.setColorMenuOpen(val);
  }
  
}
